import React from 'react';

// CD-5202 placeholder: the scheduler planned vs actual Power BI/Domo report URL is not confirmed yet.
// When it is, replace the inner div with the iframe (see OpsPBIDashboard.js).
export default function SchedulerPlannedVsActualReport() {
  return (
    <div className='contentwrapperiframe bravo-ds'>
      <div className='report-placeholder'>
        <h4>Scheduler Planned vs Actual</h4>
        <p>The monthly planned vs actual report per scheduler will be available here soon.</p>
      </div>
    </div>
  );
}
